module.exports = __webpack_public_path__ + "static/media/Noirden-Bold-oblique.55291c46.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Noirden-Bold-oblique.eot
// module id = 2946
// module chunks = 70